import React, { useEffect } from 'react';
import AuthStorage from '~/Utils/AuthStorage';
import { caracteristicas } from '~/constant';
import './ConsultaImoveis.css';

// Menu de contexto do mapa de lotes. Replica PopupMenu1 do Delphi
// (UConsultaImovel.pas linhas 153-177), porem exibe apenas acoes ja
// migradas para o extranet web: Vincular/Cancelar proposta de venda
// e Reserva Especial/Casa. As demais opcoes do Delphi (Ocorrencias,
// Situacao Cliente, Administracao de Vendas) permanecem exclusivas
// do sistema Desktop ate serem portadas.
const MenuContexto = ({
  visible,
  x,
  y,
  imovel,
  onAction,
  onClose,
  controlaPropostaVda,
}) => {
  useEffect(() => {
    if (!visible) return undefined;
    const fechar = () => onClose && onClose();
    document.addEventListener('click', fechar);
    return () => document.removeEventListener('click', fechar);
  }, [visible, onClose]);

  if (!visible || !imovel) return null;

  const temPermVinculo = AuthStorage.temCaracteristicas([caracteristicas.VinculaPropostaVenda]);
  const temPermReserva = AuthStorage.temCaracteristicas([caracteristicas.ReservaEspecial]);
  const exibeVinculoProposta = controlaPropostaVda === 'S';
  const statusD = imovel.status === 'D';
  const temReservaEspecial = imovel.tem_reserva_especial === 1;
  const temReservaCasa = imovel.tem_reserva_casa === 1;

  // Delphi PopupMenu1Popup (linhas 2539-2581):
  // - mReservaEspecial.Enabled := Status = 'D'
  // - Se ja tem RE -> caption 'Desmarcar Reserva Especial' e desabilita RC
  // - Se ja tem RC -> caption 'Desmarcar Reserva Casa' e desabilita RE
  const reservaEspecialHabilitada = statusD && temPermReserva && !temReservaCasa;
  const reservaCasaHabilitada = statusD && !temReservaEspecial;

  const labelReservaEspecial = temReservaEspecial
    ? 'Desmarcar como Reserva Especial'
    : 'Marcar como Reserva Especial';
  const labelReservaCasa = temReservaCasa
    ? 'Desmarcar Reserva Casa'
    : 'Marcar como Reserva Casa';

  const handleClick = (acao, habilitado, e) => {
    e.stopPropagation();
    if (!habilitado) return;
    onAction && onAction(acao, imovel);
    onClose && onClose();
  };

  const itemClass = (habilitado) => `menu-contexto-item${habilitado ? '' : ' disabled'}`;

  const temVinculo = exibeVinculoProposta;
  const temReservas = true;

  if (!temVinculo && !temReservas) return null;

  return (
    <div
      className="menu-contexto"
      style={{ left: x, top: y }}
      onClick={(e) => e.stopPropagation()}
    >
      {exibeVinculoProposta && (
        <>
          <div
            className={itemClass(temPermVinculo)}
            onClick={(e) => handleClick('vincular-proposta', temPermVinculo, e)}
          >
            Vincular com proposta de venda
          </div>
          <div
            className={itemClass(temPermVinculo)}
            onClick={(e) => handleClick('cancelar-vinculo', temPermVinculo, e)}
          >
            Cancelar vínculo com proposta de venda
          </div>
          <div className="menu-contexto-separator" />
        </>
      )}

      <div
        className={itemClass(reservaEspecialHabilitada)}
        onClick={(e) => handleClick('reserva-especial', reservaEspecialHabilitada, e)}
      >
        {labelReservaEspecial}
      </div>
      <div
        className={itemClass(reservaCasaHabilitada)}
        onClick={(e) => handleClick('reserva-casa', reservaCasaHabilitada, e)}
      >
        {labelReservaCasa}
      </div>
    </div>
  );
};

export default MenuContexto;
